import { paymentStatusLabel } from "./payment-status";

interface RepairSelectionOrder {
  id: string;
  recordType: string;
  financialStatus: string | null | undefined;
}

export function isUnpaidRepairSelection(workspace: string, order: RepairSelectionOrder): boolean {
  // CRS-only records have no Shopify payment status yet; keep them selectable.
  return workspace === "repair" && order.recordType === "order"
    && paymentStatusLabel(order.financialStatus) === "未払い";
}

export function pruneUnpaidRepairSelections(
  workspace: string,
  orders: RepairSelectionOrder[],
  selectedIds: Set<string>,
): void {
  for (const order of orders) {
    if (isUnpaidRepairSelection(workspace, order)) selectedIds.delete(order.id);
  }
}

export function repairCaseBadge(orderName: string): string {
  return orderName.trim().startsWith("CRS#")
    ? '<b class="repair-case-badge" aria-label="CRS受付">A</b>'
    : "";
}
